import React from 'react';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { StandoutTile } from 'web-ui-components/lib/layout/content';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import AuthCode from './components/AuthCode';
import Submit from '../../components/Submit';

const EnterAuthPage = ({ saveEnterAuthForm, getBusinessData }) => (
  <Form
    onSubmit={saveEnterAuthForm}
    initialValues={getBusinessData}
    render={({ handleSubmit }) => (
      <form onSubmit={handleSubmit}>
        <Content>
          {({ enterAuthPageTitle, enterAuthSubmit, needHelpA, needHelpB, needHelpC }) => (
            <StandardBody>
              <PageHeading>{enterAuthPageTitle}</PageHeading>
              <StandoutTile.Guidance>
                {needHelpA}
                <br />
                <strong>{needHelpB}</strong>
                <br />
                {needHelpC}
              </StandoutTile.Guidance>
              <AuthCode />
              <Submit submitButtonText={enterAuthSubmit} />
            </StandardBody>
          )}
        </Content>
      </form>
    )}
  />
);

EnterAuthPage.propTypes = {
  saveEnterAuthForm: PropTypes.func.isRequired
};

export default EnterAuthPage;
